import consumer from "./consumer";

interface AiChatSubscriptionArguments {
  chatId: string;
  onMessageReceived: (message: OpenAiMessage) => void;
  onErrorReceived: (error: string) => void;
}

export default function connectAiChatSubscription({chatId, onMessageReceived, onErrorReceived}: AiChatSubscriptionArguments) {
  return consumer.subscriptions.create({ channel: "AiChatChannel", chat_id: chatId }, {
    connected() {
      // Called when the subscription is ready for use on the server
    },

    disconnected() {
      // Called when the subscription has been terminated by the server
    },

    received(data: {message: OpenAiMessage} | {error: string}) {
      if ('message' in data) {
        onMessageReceived(data.message);
      } else {
        onErrorReceived(data.error);
      }
    },

    chat(messages: Array<OpenAiMessage>) {
      this.perform("chat", { messages: messages });
    },
  });
}
